<script>
/**
 * EcConnection configuration visualization
 */

export default {
    props: {
        context: { description: "EcConnection object" }
    }
};
</script>

<template>
    <div>
        <template v-if="context.connection_type == 1">
            {{ context.account_number }}
        </template>
        <template v-else>
            <ul class="pl-2">
                <li v-for="cr in context.schema_config.split(',')">{{ cr }}</li>
            </ul>
        </template>
    </div>
</template>
